// extracted by mini-css-extract-plugin
export default {"test-form":"IF4b80vJSl","testForm":"IF4b80vJSl"};